'use client'

import React from 'react'

import ChartWrap from './ChartWrap'
import { LineChartProps } from './types'

const LineChart = ({
	data,
	options,
	title,
	legendposition,
	gridColor = '#444444',
	aspect = 'square',
	style,
	className,
}: LineChartProps) => {
	return (
		<ChartWrap
			data={data}
			options={{
				...options,
				scales: {
					x: {
						...options?.scales?.x,
						grid: {
							...options?.scales?.x?.grid,
							color: gridColor,
						},
					},
					y: {
						...options?.scales?.y,
						grid: {
							...options?.scales?.y?.grid,
							color: gridColor,
						},
					},
				},
			}}
			title={title}
			legendposition={legendposition}
			chartType='line'
			aspect={aspect}
			className={className}
			style={style}
		/>
	)
}

export default LineChart
